import { FC } from "react";

import { useFullUserProfileContext } from "Bands/contexts";
import { copy } from "shared/assets";
import { HomeBaseTeaser, Loader, Title } from "shared/components";
import { Spacer } from "shared/layout";
import { GridContainer } from "shared/styles";
import { useFetchingContactDetails } from "Bands/utils";

const baseCopy = copy.userHomeBase;

export const HomeBases: FC = () => {
  const { homeBases } = useFullUserProfileContext();

  const { fetchingHomeBases } = useFetchingContactDetails();

  if (fetchingHomeBases) return <Loader />;
  if (!homeBases?.length) return null;

  return (
    <Spacer size="s">
      <Title title={baseCopy.title} asComponent="h3" size="s" />
      <GridContainer>
        {homeBases?.map(base => (
          <HomeBaseTeaser key={base.id} {...base} />
        ))}
      </GridContainer>
    </Spacer>
  );
};
